import { OptionalPacsParams, PacsParams } from '@models/pacs';
import { loadConfig } from '@api/api';
import axios, { AxiosResponse } from 'axios';

const make_wild_card = (content: string, c = '*') => {
  if (!content) return content;
  const left  = content.startsWith(c) ? '' : c;
  const right = content.endsWith(c)  ? '' : c;
  return `${left}${content}${right}`;
};
export function mapToPacsParams(params: PacsParams): OptionalPacsParams {
  const mapped: Record<string, string> = {
    studyUID: params.StudyUID,
    studyDate: params.StudyDate,
    studyID: params.StudyID,
    patientBirthDate: params.BirthDate,
    patientName: params.PatientName,
    patientID: params.PatientID,
    seriesUID: params.SeriesUID,
    dicomNode: params.SelectServer,
  };

  return Object.fromEntries(
    Object.entries(mapped).filter(([k, v]) =>
      k === 'dicomNode' ? true : v != null && v.trim() !== '',
    ),
  ) as OptionalPacsParams;
}


const getPacsApi = async () => {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/pacs`;
};

export const getPacsQuery = async ({
  accessToken,
  params,
  isStudy,
}: {
  accessToken: string;
  params: PacsParams;
  isStudy: boolean;
}) => {
  const PACS_URL = await getPacsApi();
  const endpoint = isStudy ? 'study' : 'series';
  const response: AxiosResponse<[]> = await axios
    .get(`${PACS_URL}/query/${endpoint}`, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
      params: mapToPacsParams(params),
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};

export const getPacsRetrieve = async ({
  accessToken,
  dicomNode,
  seriesUID,
}: {
  accessToken: string;
  dicomNode: string;
  seriesUID: string;
}) => {
  const PACS_URL = await getPacsApi();
  const response: AxiosResponse<[]> = await axios
    .get(`${PACS_URL}/retrieve/series`, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        dicomNode,
        seriesUID,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};

export const getPacsEcho = async ({
  accessToken,
  dicomNode,
}: {
  accessToken: string;
  dicomNode: string;
}) => {
  const PACS_URL = await getPacsApi();
  const response: AxiosResponse = await axios
    .get(`${PACS_URL}/echo`, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
      params: { dicomNode },
      timeout: 500,
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
};
